import * as dsteem from 'dsteem';
import axios from 'axios';
import { extractSessionData } from 'helpers/localStorage';
import { isLoggedWithKeychain } from 'services/dsteem-service';

export async function uploadImageToSteem({
  file,
  autologin,
  user,
  setErrorMessage,
}: {
  file: File;
  autologin: any;
  user: string;
  setErrorMessage: (msg: string) => void;
}): Promise<string | null> {
  let username = user;
  let wif = null;
  const keychainLogin = isLoggedWithKeychain(autologin);

  if (!keychainLogin) {
    const session = extractSessionData(autologin);
    username = session[0];
    wif = session[1];
  }

  const IMAGE_API = 'https://steemitimages.com';
  const maxSize = 5 * 1024 * 1024;

  if (file.size > maxSize) {
    setErrorMessage('Add an image up to 5 MB.');
    return null;
  }

  if (!file || !username) {
    setErrorMessage('Session error, try logging in again.');
    return null;
  }

  if (!keychainLogin && !wif) {
    setErrorMessage('Log in with username and posting key to upload.');
    return null;
  }

  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = async (event) => {
      try {
        const imageBase64 = event.target?.result?.toString().split(',')[1] || '';
        const photoBuf = new Uint8Array(Buffer.from(imageBase64, 'base64'));
        const prefix = new Uint8Array(Buffer.from('ImageSigningChallenge'));
        const data = Buffer.concat([prefix, photoBuf]);

        let signature: string;

        if (!keychainLogin) {
          const hash = dsteem.cryptoUtils.sha256(data);
          const privateKey = dsteem.PrivateKey.fromString(wif);
          signature = privateKey.sign(hash).toString();
        } else {
          const response = await new Promise<any>((resolveKeychain) => {
            window.steem_keychain.requestSignBuffer(
              username,
              JSON.stringify(data),
              'Posting',
              resolveKeychain
            );
          });

          signature = response.result;
        }

        const formData = new FormData();
        formData.append('encodedImage', imageBase64);
        formData.append('image', file);
        formData.append('signature', signature);
        formData.append('username', username);
        let response = null;
        try {
          response = await axios.post(`${IMAGE_API}/${username}/${signature}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
        } catch (error) {
          setErrorMessage(error.message || 'An error occurred.');
        }
        
        if (!response) {
          resolve(null);
        }else {
          resolve(response.data.url);
        }
        
      } catch (error: any) {
        setErrorMessage(error.message || 'An error occurred.');
        reject(error);
      }
    };

    reader.readAsDataURL(file);
  });
}
